// eslint-disable-next-line no-shadow
export enum AutocompleteChangeReasonEnum {
	CreateOption = 'createOption',
	SelectOption = 'selectOption',
	RemoveOption = 'removeOption',
	Clear = 'clear',
	Blur = 'blur',
}
